

import {translateFields, lang} from "./base.js";

function getElement(selector, element = document) {
    return element.querySelector(selector);
}


let validRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

class Form {
    constructor(form) {
        this.form = document.querySelector(form);
        this.inputs = this.form.querySelectorAll("input");
        this.path = `${path_url}/assets/services/mailAndTelegram.php`;
        this.title = getElement('input[type="hidden"]', this.form)?.value
        this.search = this.form.querySelector("[data-search]") ? this.form.querySelector("[data-search]") : null;
        // this.s = `${path}/assets/services/telegramSend.php`;
        this.date = this.form.querySelector('[data-form-date]') ? this.form.querySelector('[data-form-date]') : null;

        this.textarea = this.form.querySelector('textarea') ? this.form.querySelector('textarea') : null;
        this.formData = {};
        this.validator = {};
    }




    checkInputs() {

        this.inputs.forEach((input) => {
            if (input.type === "text") {
                this.checkTextInput(input);
            }

            if (input.name === "phone") {
                this.checkPhoneInput(input);
            }
            if (input.name === "email") {
                this.checkEmailInput(input);
            }
        });
    }

    checkEmailInput(input) {
        let {emailMessage} = translateFields;
        let templateEmail = emailMessage[lang];
        let isValid = false;
        input.addEventListener("blur", () => {
            if (input.value.match(validRegex)) {
                this.valid(input);
                isValid = true;
            } else {
                this.invalid(input);
            }
            getElement('.form__message', input.closest('.form__item')).innerHTML = isValid ? "" : templateEmail;
        });
        input.addEventListener("input", () => {
            this.valid(input);
            getElement('.form__message', input.closest('.form__item')).innerHTML = "";
        });
    }

    resetForm(btn) {
        this.formData = {
            phone: "",
            name: "",
            selected: "",
            date: '',
            comment: '',
            link: location.href
        };
        const {send} = translateFields;
        btn.dataset.form = '';
        btn.classList.remove("disabled");
        btn.innerHTML = `<span class="txt-upper">${send[lang]}</span>`;
        this.form.reset();
        this.inputs.forEach((input) => {
            input.parentNode.classList.remove('valid');
            input.value = '';
            // if (input.name == 'phone') {
            //     this.mask.updateValue();
            // }
        });
        this.checkInputs();
    }


    checkPhoneInput(input) {
        let {template: templateMessage} = translateFields;
        let template = templateMessage[lang];
        let isValid = false;


        input.addEventListener("input", () => {
            if (input.value.indexOf("_") === -1) {
                this.valid(input);
                this.formData.phone = input.value.substr(1);
                isValid = true;
            } else {
                this.invalid(input);
                isValid = false;
            }
            if (!isValid) {
                getElement('.form__message', input.parentElement).innerHTML = `${template}`;
            } else {
                getElement('.form__message', input.parentElement).innerHTML = "";
            }
        });
    }


    valid(input) {
        input.closest('.form__item').classList.add("valid");
        input.closest('.form__item').classList.remove("invalid");
        if (this.form.querySelector('button[type="submit"]').classList.contains('disabled')) this.form.querySelector('button[type="submit"]').classList.remove('disabled')
    }

    invalid(input) {
        input.closest('.form__item').classList.add("invalid");
        input.closest('.form__item').classList.remove("valid");
        this.form.querySelector('button[type="submit"]').classList.add('disabled')
    }

    validateEmptyField() {
        let {field} = translateFields;
        let validInputs = false;
        this.inputs.forEach((input) => {
            // if (input.name === "name" || input.name === "email") {
            //     updateStatus(!!input.value.trim(), input);
            // }
            if (input.type === "email" || input.type === "text" && input.name !== 'phone') {
                if (!input.value.trim()) {
                    input.closest('.form__item').classList.add("invalid");
                    getElement('.form__message', input.parentElement).innerHTML = `${
                        field[lang]
                    }`;
                } else {
                    this.valid(input);
                    getElement('.form__message', input.parentElement).innerText = "";
                    this.validator[input.name] = true;
                }
            } else if (input.name === "phone") {
                if (input.value.indexOf("_") === -1) {
                    this.valid(input);
                    getElement('.form__message', input.parentElement).innerText = "";
                    this.validator.phone = true;
                } else {
                    input.closest('.form__item').classList.add("invalid");
                    getElement('.form__message', input.parentElement).innerHTML = `${
                        field[lang]
                    }`;
                }
            }
        });

        for (let key in this.validator) {
            if (!this.validator[key]) return validInputs = false;
            validInputs = true;
        }
        return validInputs;


    }

    async sendToSheet(data) {
        try {
            const sheetsData = new FormData();
            for (let key in data) {
                sheetsData.append(`${key}`, `${data[key]}`);
            }
            const result = await fetch(
                "https://script.google.com/macros/s/AKfycbwFLvu7MShp9xsydD7exK7pLzre6plmHZWocCt94Xzsy_6KCvGWnk37WJqPBgQEzX1E/exec",
                {
                    method: "POST",
                    body: sheetsData,
                }
            );
            console.log(result)
        } catch (e) {
            console.log(e);
        }


    }


    async postData(url, data, btn) {
        getElement('.modal-pickup .modal__header h2').innerHTML = 'Вашу заявку сформовано!';
        getElement('.modal-pickup__icon').classList.remove('none');
        getElement('.modal-pickup .h3').classList.remove('none');
        getElement('.modal-pickup .modal__footer.none').classList.remove('none');
        getElement('.modal-pickup__icon').classList.add('flex');
        this.form.classList.add('none');
        // this.form
        try {
            const response = await fetch(url, {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            btn.dataset.form = 'success';
            // modalsEvents(btn);
            // new Modal(".modal__form-answer").openModal();
            this.resetForm(btn);


        } catch (error) {
            btn.dataset.form = 'erorr';
            // modalsEvents(btn);
            // new Modal(".modal__form-answer").openModal();
            this.resetForm(btn);

            console.error("Ошибка:", error);
        }
    }

    getUtmParameter(url, object) {
        if (url) {
            let urlValues;
            urlValues = url.substr(1).split("&");

            const values = urlValues.map((value) => value.split("="));
            values.forEach((item) => {
                const regex = /utm_/i;
                let name = item[0].replace(regex, "");
                object[`${name}`] = item[1]
            });
            return true;
        }
        return false;
    };

    checkTextInput(input) {
        if (input.name === 'phone') return
        let name = translateFields['validateName'][lang];
        let isValid = false;
        input.addEventListener("keypress", function (e) {
            if (!e.key.match(/^[a-zA-Zа-яА-ЯЇїІіЄєҐґЁёЭэЪъ\sğĞıİöÖüÜşŞçÇıI]/)) {
                e.preventDefault();
            }
        });
        input.addEventListener("input", () => {
            if (input.value.length >= 2) {
                this.valid(input);
                this.formData[input.name] = input.value.trim();
                isValid = true;
            } else {
                this.invalid(input);
                this.formData[input.name] = ''
                isValid = false;
            }
            if (!isValid) {
                getElement('.form__message', input.parentElement).innerHTML = `${name}`;
            } else {
                getElement('.form__message', input.parentElement).innerHTML = ``;
            }
        });
    }

    generateFormData(inputs, data) {
        inputs.forEach(input => {
            if (input.type === 'hidden' || !input.value) return
            this.formData[input.name] = input.value;
        })
        this.formData = {
            title: this.title,
            link: location.href,
            ...this.formData,
            ...data
        };

    }

    submit(variationItem, stores) {
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();

            if (this.validateEmptyField()) {
                e.submitter.classList.add("disabled");
                e.submitter.innerHTML = `<svg class="icon btn__spinner">
        <use xlink:href="#spinner"></use>
      </svg>`;
                const shopId = getElement('.pickup-item.active').dataset.shop;
                const shop = stores.find(item => item.id === +shopId);
                const data = {
                    sku: variationItem['sku'],
                    city: shop['city'],
                    telegram: shop['telegram'],
                }
                if (tokenKey) {
                    data['token'] = tokenKey;
                }
                this.generateFormData(this.inputs, data)
                this.postData(this.path, this.formData, e.submitter);
            }


        });

    }

    submitProductPartner(variationItem, stores) {
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();

            if (this.validateEmptyField()) {
                e.submitter.classList.add("disabled");
                e.submitter.innerHTML = `<svg class="icon btn__spinner">
        <use xlink:href="#spinner"></use>
      </svg>`;
                const shopId = getElement('.pickup-item.active').dataset.shop;
                const shop = stores.find(item => item.store.odoo_id == +shopId);
                console.log(shop, shopId, variationItem, 222)
                const data = {
                    sku: variationItem['sku'],
                    // TODO у форму тг відправляється ['sku']. Зараз undefined
                    city: shop['store']['city'],
                    telegram: shop['store']['telegram'],

                }
                if (tokenKey) {
                    data['token'] = tokenKey;
                }
                console.log(data)
                this.generateFormData(this.inputs, data)
                this.postData(this.path, this.formData, e.submitter);
            }


        });

    }

    init() {

        const selected = getElement('[data-selected]', this.form);

        this.checkInputs();
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();


            if (getElement('.doctor-page')) {
                if (!this.form.closest('.doctor-page')) {
                    this.formData.selected = null;
                    this.formData.doctor = selected.dataset.selected;
                } else {
                    this.formData.doctor = getElement('h1', getElement('.doctor-page')).innerText.trim();
                }
            }
            if (this.validateEmptyField()) {
                e.submitter.classList.add("disabled");
                e.submitter.innerHTML = `<svg class="icon btn__spinner">
        <use xlink:href="#spinner"></use>
      </svg>`;

                this.postData(this.path, this.formData, e.submitter);
            }
        });
    }

    reportForm() {
        this.create();
        this.checkInputs();
        this.form.addEventListener("submit", async (e) => {
            e.preventDefault();
            if (this.validateEmptyField()) {
                e.submitter.classList.add("disabled");
                e.submitter.innerHTML = `<svg class="icon btn__spinner">
        <use xlink:href="#spinner"></use>
      </svg>`;
                this.inputs.forEach(input => {
                    if (input.name) {
                        this.formData[input.name] = input.value
                    }
                })
                let action = ajax_url + '?action=uarm_post_report_form';
                try {
                    const response = await fetch(action, {
                        method: "POST",
                        body: JSON.stringify(this.formData),
                        headers: {
                            "Content-Type": "application/json",
                        },
                    });

                    if (response.status !== 200) throw new Error('error');
                    const data = await response.json();

                    const modal = this.form.closest('.modal')
                    getElement('.modal__header h2', modal).innerHTML = '';
                    getElement('.modal__footer', modal).remove();
                    getElement('.modal__content', modal).innerHTML = `
                    <div class="h2">Thanks, we will reach you back as soon as the product is on the way to our warehouse</div>`;


                } catch (error) {
                    console.error("Ошибка:", error);
                }


                // console.log(data)
                // this.generateFormData(this.inputs, data)
                // this.postData(this.path, this.formData, e.submitter);
            }


        });
    }

    create() {
        this.inputs.forEach(input => {
            if (input.name && input.name !== 'sku') {
                this.validator[input.name] = null
            }
        })
        return this;
    }

    log() {
        console.log(this.formData)
    }
}

export default Form;

